import { render, staticRenderFns } from "./ClientInvoiceList.vue?vue&type=template&id=288fecb8&"
import script from "./ClientInvoiceList.vue?vue&type=script&lang=js&"
export * from "./ClientInvoiceList.vue?vue&type=script&lang=js&"
import style0 from "./ClientInvoiceList.vue?vue&type=style&index=0&id=288fecb8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports